import { render, staticRenderFns } from "./70ksubpage.vue?vue&type=template&id=55c82ac5&"
import script from "./70ksubpage.vue?vue&type=script&lang=js&"
export * from "./70ksubpage.vue?vue&type=script&lang=js&"
import style0 from "./70ksubpage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports